import React, { useEffect } from "react";
import PropTypes from "prop-types";
/* Components */
import BlurredNumber from "../../CommonForBoth/Blurred/BlurredNumber";
import { Container, Row, Col } from "react-bootstrap";
import { Card } from "semantic-ui-react";
import Badges from "../../CommonForBoth/Badges";
/* i18n */
import { connect, useDispatch } from "react-redux";
import { withTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
/* Store */
import { selectEthCallMultiple } from "@ensuro/ethereum-store/src/store/ethereum/selectors";
import { selectAPICallMultiple } from "@ensuro/api-calls-store/src/store/api/selectors";
/* Helpers */
import defaultRiskLogo from "../../../assets/images/risks-symbol.png";
import { addRemoveSub } from "../../../helpers/store_helper";
import "./../style.scss";

const makeEthCalls = function (rkAddress) {
  return [
    { address: rkAddress, abi: "RiskModule", method: "params", args: [] },
    { address: rkAddress, abi: "RiskModule", method: "activeExposure", args: [] },
  ];
};

const makeAPICalls = (rkAddress) => {
  return [
    { apiName: "activePolicies", args: [rkAddress] },
    { apiName: "maturedSurplus", args: [rkAddress] },
    { apiName: "gwp", args: [rkAddress] },
    { apiName: "scr", args: [rkAddress] },
  ];
};

const RiskRowDesktop = ({ t, risk, idx, jrRoc, srRoc, activePolicies, maturedSurplus, gwp, scr, rmBadges }) => {
  const navigate = useNavigate();
  let dispatch = useDispatch();
  let tags = risk.custom_data?.tags || [];

  const handleCardClick = (address) => {
    navigate(`/risks/${address}`);
  };

  useEffect(() => {
    return addRemoveSub(
      dispatch,
      `riskDesktop-${risk.address}`,
      makeAPICalls(risk.address),
      makeEthCalls(risk.address)
    );
  }, [dispatch, risk.address]);

  return (
    <Container className="desktop no-margin">
      <Card className="card-row card-hover" onClick={() => handleCardClick(risk.address)} key={idx}>
        <Container className="no-margin">
          <Row>
            <Col md={2} className="font-size-16 name-with-logo margin-auto">
              <span className="logo-sm with-20-padding">
                <img src={risk.logo || defaultRiskLogo} alt="" height="35" />
              </span>{" "}
              {risk.name} <Badges tags={tags} badgesData={rmBadges || []} />
            </Col>
            <Col md={2}>
              <Card className="card-inside primary-colored">
                <BlurredNumber number={activePolicies} options={{ notation: "standard" }} />
              </Card>
            </Col>
            <Col md={1}>
              <Card className="card-inside primary-colored">
                <BlurredNumber number={gwp} options={{ maximumFractionDigits: 2, notation: "compact" }} />
              </Card>
            </Col>
            <Col md={2}>
              <Card className="card-inside primary-colored">
                <BlurredNumber
                  number={jrRoc}
                  suffix={"%"}
                  percentage={true}
                  options={{ maximumFractionDigits: 2, notation: "standard" }}
                />
              </Card>
            </Col>
            <Col md={2}>
              <Card className="card-inside primary-colored">
                <BlurredNumber
                  number={srRoc}
                  suffix={"%"}
                  percentage={true}
                  options={{ maximumFractionDigits: 2, notation: "standard" }}
                />
              </Card>
            </Col>
            <Col md={1}>
              <Card className="card-inside primary-colored">
                <BlurredNumber number={scr} options={{ maximumFractionDigits: 2, notation: "compact" }} />
              </Card>
            </Col>
            <Col md={2}>
              <Card className="card-inside" style={{ color: Math.sign(maturedSurplus.value) < 0 ? "red" : "green" }}>
                <BlurredNumber number={maturedSurplus} options={{ maximumFractionDigits: 2, notation: "compact" }} />
              </Card>
            </Col>
          </Row>
        </Container>
      </Card>
    </Container>
  );
};

RiskRowDesktop.propTypes = {
  t: PropTypes.any,
};

const mapStateToProps = (state, ownProps) => {
  const rkAddress = ownProps.risk.address;
  const [params] = selectEthCallMultiple(state.EthereumReducer, makeEthCalls(rkAddress));
  const [activePolicies, maturedSurplus, gwp, scr] = selectAPICallMultiple(state.APIReducer, makeAPICalls(rkAddress));

  const jrRoc = params.value ? { value: params.value[5], state: "LOADED" } : {};
  const srRoc = params.value ? { value: params.value[6], state: "LOADED" } : {};

  return { jrRoc, srRoc, activePolicies, maturedSurplus, gwp, scr };
};

export default connect(mapStateToProps)(withTranslation()(RiskRowDesktop));
